import React, { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { getUser, isLoggedIn, loadLocalUser } from "../../controller/reducer/user";
import Header from "./common/header";
import NotFound from "./common/NotFound";
import KeyResources from "./key-resources";
import KeyResEditor from "./key-resources/editor";
import LocationResources from "./location-resources";
import LocationItem from "./location-resources/item";
import LocationResEditor from "./location-resources/item/editor";
import LoginPage from "./login";
import Remedies from "./remedies";
import RemedyItemEditor from "./remedies/editor";
import UserList from "./user";

function Home() {
  const loggedIn = useSelector(isLoggedIn);
  const user = useSelector(getUser);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(loadLocalUser());
  }, [dispatch]);

  // useEffect(() => {
  //   // dispatch(loadLocalUser());
  // }, [loggedIn])

  if (!loggedIn) {
    return <LoginPage dispatch={dispatch} />;
  }
  return (
    <Router>
      <div className="App">
        <Header />
        <Switch>
          <Route path="/admin/" exact component={LocationResources} />
          {/* <Route path="/admin/" exact component={LoginPage} /> */}
          <Route path="/admin/remedies" exact component={Remedies} />
          <Route path="/admin/key-resources" exact component={KeyResources} />
          <Route
            path="/admin/key-resources/editor"
            exact
            component={KeyResEditor}
          />
          <Route path="/admin/remedy" exact component={RemedyItemEditor} />
         {( user.type === "root"|| user.type === "super" ) && <Route path="/admin/user" exact component={UserList} />}
          <Route
            path="/admin/location/editor"
            exact
            component={LocationResEditor}
          />
          <Route path="/admin/location/:name" exact component={LocationItem} />
          <Route path="*" component={NotFound}/>
        </Switch>
      </div>
    </Router>
  );
}

export default Home;
